import type LxcError from "~/core/models/LxcError.class";
import RestService from "~/core/services/rest.service";
import type { UserIdentity } from "~/modules/user/models/UserIdentity.interface";
import type { UserSession } from "~/modules/user/models/UserSession.interface";

export class UserService extends RestService {
  protected BASE_URL = "users";

  /**
   * Retrieve current user
   */
  getCurrentUser(): Promise<UserSession> {
    return this.$apiV2.get(`${this.BASE_URL}/me`);
  }

  /**
   * Set session
   * @param code
   * @param redirectUri
   */
  setSession(code: string, redirectUri: string): Promise<UserSession> {
    const params = {
      code,
      redirectUri,
    };

    return this.$api.get(`${this.BASE_URL}/session`, { params });
  }

  /**
   * Update user
   * @param user
   */
  updateUser(user: UserIdentity): Promise<UserIdentity | LxcError> {
    return this.$api.put(`${this.BASE_URL}/${user.id}`, { user });
  }
}

export default new UserService();
